export const postCategories = [
    { label: "Politics", value: "politics" },
    { label: "News", value: "news" },
    { label: "Sports", value: "sports" },
    { label: "Entertainment", value: "entertainment" },
    { label: "Technology", value: "technology" },
    { label: "Health & Wellness", value: "health_wellness" },
    { label: "Travel", value: "travel" },
    { label: "Lifestyle", value: "lifestyle" },
    { label: "Education", value: "education" },
    { label: "Business", value: "business" },
    { label: "Science", value: "science" },
    { label: "Environment", value: "environment" },
    { label: "Food", value: "food" },
    { label: "Photography", value: "photography" },
    { label: "Art", value: "art" },
    { label: "Music", value: "music" },
    { label: "Books", value: "books" },
    { label: "Fashion", value: "fashion" },
    { label: "Gaming", value: "gaming" },
    { label: "Culture", value: "culture" },
    { label: "Entrepreneurship", value: "entrepreneurship" },
    { label: "Fitness", value: "fitness" },
    { label: "Self-Improvement", value: "self_improvement" },
    { label: "Motivation", value: "motivation" },
    { label: "Life Advice", value: "life_advice" },
    { label: "Charity & Community", value: "charity_community" },
    { label: "Family & Relationships", value: "family_relationships" },
    { label: "Personal Stories", value: "personal_stories" }
  ];
  